import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import CurriculumInfoList from 'app/Homepage/components/CurriculumInfoList'
import { GATrackEvent } from 'utils/googleAnalytics'

import ArrowLeftIcon from 'assets/icons/arrow-left.svg'

function KurikulumMerdekaPageHeader() {
  const title = 'Tentang Kurikulum Merdeka'
  const router = useRouter()

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <HeaderBar fixed variant="large" className="!shadow-none">
        <HeaderBarLeftAction
          onClick={() =>
            historyUtils.backToApp(() => {
              if (window.history.state.idx <= 1) router.push('/home')
              else router.back()
            })
          }
        >
          <ArrowLeftIcon
            width={24}
            height={24}
            className="fill-current text-icon-default"
          />
        </HeaderBarLeftAction>
        <HeaderBarTitle>{title}</HeaderBarTitle>
      </HeaderBar>
    </>
  )
}

export default function KurikulumMerdekaPage() {
  React.useEffect(() => {
    GATrackEvent({
      eventName: 'ABOUT_KM_VIEW_HOME',
      eventParams: {},
    })
  }, [])

  return (
    <div className="pt-14 px-4 pb-14 leading-loose">
      <CurriculumInfoList />
      <a
        href="https://drive.google.com/drive/folders/1p7JrPQkHNIJIf2tjMefL_eNJFa2BUWY1"
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          GATrackEvent({
            eventName: 'ABOUT_KM_CLICK_EXTERNAL_FOLDER',
            eventParams: {},
          })
        }
      >
        <div className="p-4 bg-white rounded-lg border border-subdued flex gap-4">
          <div className="flex justify-center items-center">
            <div className="rounded-lg bg-surface-neutral-default p-2 w-10 h-10">
              <Icon>call_made</Icon>
            </div>
          </div>
          <div className="flex-1 text-lg font-semibold">
            Kumpulan dokumen panduan pelaksanaan Kurikulum Merdeka
          </div>
        </div>
      </a>
    </div>
  )
}

KurikulumMerdekaPage.layoutOpts = {
  hasBottomNav: false,
  hasHeader: true,
  header: KurikulumMerdekaPageHeader,
}
